import { collection, getDocs, limit, query, where } from "firebase/firestore";
import { useState, useRef } from "react";
import { firestore } from "../firebase/config";
import { PLAYER_SEARCH_DELAY } from "../constants";
import SaveIndicator from "./SaveIndicator";

const PlayerSearch = ({
  index,
  playerName,
  onChange,
  onSelect,
  saveStatus,
}) => {
  const [searchValue, setSearchValue] = useState(playerName ?? "");
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);
  const searchTimeoutRef = useRef(null);

  const handleSearchValueChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);

    if (!value || value.length < 3 || value === playerName) {
      setFilteredProfiles([]);
      setIsDropdownOpen(false);
      return;
    }

    onChange(value, index);

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(async () => {
      const text = value.trim().toLowerCase();
      if (!text || text.length < 3) {
        setFilteredProfiles([]);
        setIsDropdownOpen(false);
        return;
      }

      try {
        const profilesRef = collection(firestore, "profiles");
        const q = query(
          profilesRef,
          where("name", ">=", text),
          where("name", "<=", text + "\uf8ff"),
          limit(5)
        );

        const snapshot = await getDocs(q);
        const results = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setFilteredProfiles(results);
        setIsDropdownOpen(true);
      } catch (error) {
        console.error("Error fetching profiles:", error);
      }
    }, PLAYER_SEARCH_DELAY);
  };

  const handleProfileSelect = async (profile) => {
    const { id, name } = profile;

    setSearchValue(name);
    setFilteredProfiles([]);
    setIsDropdownOpen(false);

    await onSelect(id, index);
  };

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <input
        className="w-full border px-2 py-1 rounded"
        onChange={(event) => handleSearchValueChange(event)}
        placeholder="Enter player name"
        value={searchValue}
      />

      <div className="absolute top-3 right-1">
        <SaveIndicator saveStatus={saveStatus} />
      </div>

      {isDropdownOpen && filteredProfiles.length > 0 && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-auto">
          {filteredProfiles.map((player) => (
            <div
              key={player.id}
              onClick={() => handleProfileSelect(player)}
              className="p-2 cursor-pointer hover:bg-gray-100 text-sm"
            >
              {player.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PlayerSearch;
